import { Link, useLocation } from "react-router-dom";

export default function SiteLink({ href, onClick, children, ...rest }) {
  const { pathname } = useLocation();

  const handleClick = (e) => {
    onClick?.(e);
    if (href.startsWith("/#") && pathname === "/" && href !== "/#walkthrough") {
      const el = document.getElementById(href.slice(2));
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        window.history.replaceState(null, "", href);
      }
    }
  };

  return (
    <Link to={href} onClick={handleClick} {...rest}>
      {children}
    </Link>
  );
}
